import { render, staticRenderFns } from "./ProgramAudioFilesForm.vue?vue&type=template&id=7810bad4&scoped=true"
import script from "./ProgramAudioFilesForm.vue?vue&type=script&lang=js"
export * from "./ProgramAudioFilesForm.vue?vue&type=script&lang=js"
import style0 from "./ProgramAudioFilesForm.vue?vue&type=style&index=0&id=7810bad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810bad4",
  null
  
)

export default component.exports